export default __webpack_public_path__ + "static/media/08_kontrola-vyvoje-kurovcu.df9274fb.jpg";